module.exports = "<svg width=\"14\" height=\"3\" viewBox=\"0 0 14 3\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 2.68722H0V0.342468H14V2.68722Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/minus-white.svg
// module id = 305
// module chunks = 0